import { Divider, Drawer, List, ListItem, ListItemIcon, ListItemText, ListSubheader, Theme, withStyles, WithStyles } from "@material-ui/core";
import HomeIcon from "@material-ui/icons/Home";
import { push } from "connected-react-router";
import * as React from "react";
import { connect } from "react-redux";
import { AccountSum } from "./app/AccountAnalyze";
import { AppState } from "./redux";
import { primaryAccounts, secondaryAccounts } from "./redux/selectors";

export const drawerWidth = 240;
const styles = (theme: Theme) => ({
  root: {
    display: "flex"
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  toolbar: theme.mixins.toolbar,
  paper: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2
  }
});

interface Props extends WithStyles<typeof styles> {
  primaryAccountData: AccountSum[];
  secondaryAccountData: AccountSum[];
  link: (path: string) => void;
}

const Sidebar = ({ classes, primaryAccountData, secondaryAccountData, link }: Props) => (
  <nav>
    <Drawer
      variant="permanent"
      open
      className={classes.drawer}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <div>
        <div className={classes.toolbar} />
        <Divider />
        <List>
          <ListItem button onClick={() => link("/")}>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Übersicht" />
          </ListItem>
          <ListSubheader style={{ background: "white" }}>Haupt-Konten</ListSubheader>
          {primaryAccountData.map((a, i) => (
            <ListItem button key={i} onClick={() => link("/detail/" + a.accountNumber)}>
              <ListItemText primary={a.accountNumber} />
            </ListItem>
          ))}
          <ListSubheader style={{ background: "white" }}>Neben-Konten</ListSubheader>
          {secondaryAccountData.map((a, i) => (
            <ListItem button key={i} onClick={() => link("/detail/" + a.accountNumber)}>
              <ListItemText primary={a.accountNumber} />
            </ListItem>
          ))}
        </List>
        <Divider />
      </div>
    </Drawer>
  </nav>
);

export default withStyles(styles)(
  connect(
    (state: AppState) => ({
      primaryAccountData: primaryAccounts(state),
      secondaryAccountData: secondaryAccounts(state)
    }),
    dispatch => ({
      link: (path: string) => dispatch(push(path))
    })
  )(Sidebar)
);



// WEBPACK FOOTER //
// ./src/Sidebar.tsx